
import React, { useState } from "react";
import { Grid, Card, CardContent, Button, Box } from "@mui/material";
import { useNavigate } from "react-router-dom";

export const ReportPage: React.FC = () => {
  const navigate = useNavigate();
  const [selected, setSelected] = useState<string>("");

  const reportOptions = [
    { label: "Sales Report", path: "/report/sales" },
    { label: "Lead Report", path: "/report/lead" },
    { label: "Invoice Report", path: "/report/invoice" },
    { label: "Profit & Loss Report", path: "/report/profit" },
    { label: "Estimation Report", path: "/report/estimation" },
    { label: "Quotation Report", path: "/report/quotation" },
    { label: "Purchase Report", path: "/report/purchase" },
    { label: "Sales By Lead Report", path: "/report/salesbylead" },
    { label: "Work Order Report", path: "/report/work-order" },
  ];

  const handleClick = (path: string) => {
    setSelected(path);
    navigate(path);
  };

  return (
    <Grid container xs={12} md={8}>
      <Box sx={{ width: "100%", padding: "0px 20px", fontWeight: 700, fontSize: "1.4rem", mt: 1, mb: 1 }}>
        REPORTS
      </Box>

      <Grid item xs={12}>
        <Card sx={{ m: 2 }}>
          <CardContent>
            <Grid container spacing={2}>
              {reportOptions.map((item) => (
                <Grid item xs={12} md={6} key={item.path}>
                  <Button
                    fullWidth
                    variant={selected === item.path ? "contained" : "outlined"}
                    sx={{
                      height: "70px", // INCREASED SIZE
                      fontWeight: 600,
                      fontSize: "1rem",
                      borderRadius: "10px",
                      "&:hover": {
                        backgroundColor: "primary.main",
                        color: "#fff",
                        borderColor: "primary.main",
                      },
                    }}
                    onClick={() => handleClick(item.path)}
                  >
                    {item.label}
                  </Button>
                </Grid>
              ))}
            </Grid>
          </CardContent>
        </Card>
      </Grid>
    </Grid>
  );
};
